import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import SimpleTooltip from "../tooltips/tooltip";
import StyledButton from "./styledButton";
import Icon from "../icon";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

interface ExpandAllButtonProps {
  expanded: boolean;
  onToggle: () => void;
}

const ExpandAllButton: React.FC<ExpandAllButtonProps> = ({ expanded, onToggle }) => {
  const label = LocalizationHelperInstance.getFormattedMessage(
    expanded ? TranslationKeys.Common.CollapseAllRows : TranslationKeys.Common.ExpandAllRows
  );

  return (
    <SimpleTooltip text={label}>
      <div>
        <StyledButton size="sm" className={cssExports.iconButton} testId="expandAllButton" onClick={onToggle}>
          <Icon icon={expanded ? IconDefinitionConstants.WCollapseAll : IconDefinitionConstants.WExpandAll} />
        </StyledButton>
      </div>
    </SimpleTooltip>
  );
};

export default ExpandAllButton;
